import { Button, TextField } from "@mui/material";
import { FC, useState } from "react";

interface ISearch {
  onSubmit: (searchQuery: string) => void;

}

const SearchComponent: FC<ISearch> = ({
  onSubmit,

}) => {
  const [searchQuery, setSearchQuery] = useState("");
  return (
    <form onSubmit={(e) => {
      e.preventDefault();
      onSubmit(searchQuery)
    }}>
      <TextField
        sx={{
          m: 1.5,
          flexGrow: 1,
          width: "calc(100% - 250px)"
        }}

        type="text"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder="Search..."
      />
      <Button sx={{ m: 1.5, padding: "7px 20px" }}
        variant="contained"
        type="submit">Search</Button>
      <Button sx={{ m: 1.5, padding: "7px 20px" }}
        variant="contained"
        color="inherit"
        onClick={() => {
          setSearchQuery("");
          onSubmit("");
        }}
      >Clear</Button>
    </form>
  );
};

export default SearchComponent;
